import React, { ReactNode, forwardRef, ComponentPropsWithRef } from 'react';
import { isKey } from '../../common/utils/KitCommon';
import { CardListItem, CardWrapper, CardHeader, CardBody, CardTitle, CardSubtitle } from './styles';

export interface KitCardProps extends ComponentPropsWithRef<'div'> {
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

const KitCard = forwardRef<HTMLDivElement, KitCardProps>((props: KitCardProps, ref) => {
  const { className, children, disabled, onClick, ...rest } = props;

  const onKeyDown = (event) => {
    if (isKey(['ENTER', 'SPACE'], event)) {
      if (onClick) {
        onClick();
      }
      event.stopPropagation();
    }
  };

  const renderCard = () => {
    return (
      <CardWrapper
        className={className}
        onKeyDown={onClick && !disabled ? onKeyDown : undefined}
        onClick={onClick && !disabled ? onClick : undefined}
        tabIndex={onClick && !disabled ? 0 : undefined}
        ref={ref}
        {...rest}
        role={onClick ? 'button' : undefined}
      >
        {children}
      </CardWrapper>
    );
  };

  if (rest.role === 'listitem') {
    return <CardListItem role='listitem'>{renderCard()}</CardListItem>;
  }

  return renderCard();
});

export default Object.assign(KitCard, {
  Header: CardHeader,
  Body: CardBody,
  Title: CardTitle,
  Subtitle: CardSubtitle,
});
